export default "__VITE_ASSET__1KhffCAZ__"